// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2UxcJ","title":"Images90_title__3jAGy","images":"Images90_images__kn0MN"};